import React from 'react';
import { motion } from 'framer-motion';

const Clients = () => {
  const clients = [
    {
      id: 'celepsa',
      name: 'Celepsa',
      logo: '/assets/clientes/Celepsa.png'
    },
    {
      id: 'electrozana',
      name: 'Electrozaña',
      logo: '/assets/clientes/Electrozaña.png'
    },
    {
      id: 'veproin',
      name: 'Veproin',
      logo: '/assets/clientes/Veproin.png'
    },
    {
      id: 'termodinamica',
      name: 'Termodinámica',
      logo: '/assets/clientes/Termodinamica.png'
    },
    {
      id: 'brametsa',
      name: 'Brametsa',
      logo: '/assets/clientes/Brametsa.png'
    },
    {
      id: 'sinergia',
      name: 'Sinergia',
      logo: '/assets/clientes/Sinergia.png'
    }
  ];

  return (
    <section 
      id="clientes" 
      className="py-20 bg-gradient-to-b from-white to-gray-50 section-top-spacing"
    >
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">Nuestros Clientes</h2>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
            Trabajamos con una amplia variedad de clientes en sectores industriales y comerciales.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
          {clients.map((client, index) => (
            <motion.div
              key={client.id}
              className="flex items-center justify-center p-6 bg-white rounded-2xl shadow-md border border-gray-100"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
            >
              <div className="flex items-center justify-center w-full h-20">
                <img 
                  src={client.logo} 
                  alt={client.name} 
                  className="max-h-16 object-contain"
                />
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-8 text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">Industrias que Atendemos</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🏭</span>
              </div>
              <h3 className="font-semibold">Minería</h3>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🏗️</span>
              </div>
              <h3 className="font-semibold">Construcción</h3>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">⚙️</span>
              </div>
              <h3 className="font-semibold">Manufactura</h3>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">⚡</span>
              </div>
              <h3 className="font-semibold">Energía</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;